import React, { Component } from "react";
import styled from "styled-components";

export class DeleteFile extends Component {
  render() {
    const {
      handleDeleteFile,
      onDownloadFile,
      fileName,
    } = this.props;
    return (
      <FileBox>
        <button
          type="button"
          className="download-file-btn"
          onClick={() => {
            onDownloadFile();
          }}
        >
          {fileName || "-"}
        </button>
        <button
          type="button"
          className="delete-file-btn"
          onClick={() => {
            handleDeleteFile();
          }}
        >
          파일 삭제
        </button>
      </FileBox>
    )
  }
}

const FileBox = styled.div`
  display: inline-block;
  vertical-align: middle;

  .download-file-btn {
    text-align: left;
    height: auto;
    padding: 10px 12px;
    background: transparent;
    color: #a9a9a9;
    height: 45px;
    vertical-align: middle;
    min-width: 100px;
    margin: 2px 0;
    font-size: 15px;
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 0 12px;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 4px;
    width: 436px;

    &:hover {
      border: 1px solid var(--secondary-500);
      color: var(--secondary-500);
    }
  }

  .delete-file-btn {
    display: inline-block;
    width: 120px;
    padding: 10px 0;
    text-align: center;
    background-color: #FF4242;
    border: 1px solid #FF4242;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    border-radius: 5px;
    margin-left: 12px;
    cursor: pointer;
  }
`;